import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { FlexRow, IconButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const AddonsCartBannerWrapper = styled(Flex)`
    height: 48px;
    padding: 8px 8px 8px 16px;
    border-radius: 4px;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    background: ${colorsPalettes.bluegrey[100]};
`;

export const AddonsCartLeftPart = styled(FlexRow)`
    align-items: center;
    gap: 8px;
    cursor: default;
`;

export const AddonsCartRightPart = styled(FlexRow)`
    align-items: center;
    gap: 6px;
`;

export const AddonsCartReviewCart = styled(IconButton)`
    height: auto !important;
    padding: 8px 16px;
`;
